import React, { useEffect, useState, useContext } from 'react';
import axios from "axios"
import RecipeTagSidebar from "components/Sidebar/SidebarContainer";
import RecipeFilterButton from "components/FilterButton/RecipeFilterButton";
import RecipeTagTopbar from "components/Topbar/RecipeTags";
import RecipeLists from "components/RecipeLists/RecipesContainer";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import useWindowDimensions from "common/hook/useWindowDimensions";
import { countSelectedTags } from "common/recipe-helper";
import NoMatch from 'components/NoMatchError/NoMatch';
import RecipesContext from "context/RecipeContext";
import CircularIndeterminate from 'components/ProgressSpinner/CircularIndeterminate';
import { useHistory } from "react-router-dom";
import "./RecipePage.css";

const theme = createTheme({
  breakpoints: {
    values: {
     sm2: 767
    }
  }
});

export default function App() {
  const [results, setResults] = useState([]);
  const { 
    recipes, 
    tagsSelected, 
    queryParams 
  } = useContext(RecipesContext.context);
  const history = useHistory();

  let showSidebar = null;
  let showFilterButton = null;

  const { width } = useWindowDimensions();

  if (width <= 992) {
    showFilterButton = <RecipeFilterButton api={results}/>;
  } else {
    showSidebar = <RecipeTagSidebar api={results}/>
  }

  const fetchWordpressApi = () => {
    axios.get("https://www.striim.com/wp-json/wp/v2/striim_recipe")
      .then(res => res.data)
      .then(data => {
        let recipeData = [];
        for (let i = 0; i < data.length; i++) {
          let recipe = data[i];
          const obj = {
            title: recipe.title.rendered,
            content: (recipe.content.rendered).replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, ''),
            role: recipe.acf.role,
            industry: recipe.acf.industry,
            platforms: recipe.acf.platforms,
            usecases: recipe.acf.usecases,
            authorName: recipe.acf.author_name,
            authorImage: recipe.acf.author_image,
            recipeImage: recipe.acf.recipe_image,
            link: recipe.acf.link
          }
          recipeData.push(obj);
        }
        setResults(recipeData);
      })
      .catch(err => console.log(err));
  }

  useEffect(() => {
      fetchWordpressApi();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams();

    if (queryParams.length > 0) {
      params.append("categories", queryParams)
    } else {
      params.delete("categories")
    }
    history.push({
      search: encodeURI(params).replace(/%3D/g,"=").replace(/%252C/g,",")
    });
  }, [queryParams, history]);

  if (results.length === 0) {
    return <CircularIndeterminate/>;
  } 

  return (
    <div className="striim-recipe-wrapper">
        <div className="react-recipe-row"> 
          {showSidebar}
          <div className="react-recipe-col">
            <RecipeTagTopbar/>
            <MuiThemeProvider theme={theme}>
              {(recipes.size === 0) && (countSelectedTags(tagsSelected) > 0) ? 
                <NoMatch /> : 
                <RecipeLists unfilteredRecipes = {results}/>
              }
            </MuiThemeProvider>
            {showFilterButton} 
          </div>
        </div>
    </div>
  )
};
